@if (state(); as state) {
  <div class="flex flex-col gap-6">
    <div class="flex flex-col sm:flex-row gap-3">
      <div class="flex flex-col flex-1">
        <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
          {{ 'cockpit.settings.members.page.title' | transloco }}
        </h3>
        <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
          {{ 'cockpit.settings.members.page.subtitle' | transloco }}
        </p>
      </div>
      <div class="flex-none flex flex-col sm:flex-row gap-2 sm:items-center">
        <ui-button type="button" expand="full" (click)="createInviteDialog.showModal()">
          {{ 'cockpit.settings.members.page.inviteButton' | transloco }}
        </ui-button>
      </div>
    </div>

    @if (members.isLoading() || invites.isLoading()) {
      {{ 'cockpit.settings.members.page.loading' | transloco }}
    } @else if (members.error() || invites.error()) {
      {{ 'cockpit.settings.members.page.error' | transloco }}
    } @else {
      <table
        class="relative min-w-full table-fixed divide-y divide-outline dark:divide-outline-darkmode"
      >
        <thead>
          <tr>
            <th class="px-3 py-3.5 text-start text-sm whitespace-nowrap font-semibold">
              {{ 'cockpit.settings.members.page.table.email' | transloco }}
            </th>
            <th class="px-3 py-3.5 text-start text-sm whitespace-nowrap font-semibold">
              {{ 'cockpit.settings.members.page.table.name' | transloco }}
            </th>
            <th class="px-3 py-3.5 text-start text-sm whitespace-nowrap font-semibold">
              {{ 'cockpit.settings.members.page.table.role' | transloco }}
            </th>
          </tr>
        </thead>
        <tbody
          class="divide-y divide-outline bg-surface dark:divide-outline-darkmode dark:bg-surface-darkmode"
        >
          @for (invite of invites.value(); track invite.id) {
            <tr>
              <td class="px-3 py-3.5 text-sm whitespace-nowrap">
                ({{ invite.status | inviteStatus | transloco }}) {{ invite.toEmail }}
              </td>
              <td></td>
              <td class="px-3 py-3.5 text-sm whitespace-nowrap">
                {{ invite.roleId | organizationRole | transloco }}
              </td>
            </tr>
          }
          @for (member of members.value(); track member.id) {
            <tr>
              <td class="px-3 py-3.5 text-sm whitespace-nowrap">{{ member.email }}</td>
              <td class="px-3 py-3.5 text-sm font-semibold whitespace-nowrap">
                {{ member.firstName }} {{ member.lastName }}
              </td>
              <td class="px-3 py-3.5 text-sm whitespace-nowrap">
                {{ member.roleId | organizationRole | transloco }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <ui-simple-dialog #createInviteDialog>
    <app-settings-orga-invite-create-dialog
      class="w-full"
      (clickCancel)="createInviteDialog.close()"
      (createSuccess)="onCreateMemberSubmit(createInviteDialog)"
      [organizationId]="state.id"
    />
  </ui-simple-dialog>
}
